import { CreateFileInput } from "../../backend/generated/create-file-input";
import { File } from "../../backend/generated/file-model";
import { GenerateUploadSignedUrlInput } from "../../backend/generated/generate-upload-signed-url-input";
import { convertToKey, convertToValue } from "../../backend/types/serialization";
import { MimeTypes } from "../../backend/types/utils";
import { extract, prune } from "../../utils/utility";
import { validateRequiredNotDefault } from "../../utils/validation";

export class FileManageable extends File {
  constructor(obj: any) {
    super();

    const defaultFileData = FileManageable.default();

    if (obj) {
      Object.assign(
        this,
        defaultFileData,
        prune(extract(
          obj,
          Object.keys(this)
        )),
        {
          mimeType: obj.mimeType ? convertToValue(
            MimeTypes,
            obj.mimeType
          ) || defaultFileData.mimeType : defaultFileData.mimeType
        }
      );
    } else {
      Object.assign(
        this,
        defaultFileData
      );
    }
  }

  static default(): any {
    return { ...new File() }
  }
}

export class CreateFileManageable extends CreateFileInput {
  constructor(obj?: any) {
    super();

    const defaultFileData = CreateFileManageable.default();

    if (obj) {
      Object.assign(
        this,
        defaultFileData,
        prune(extract(
          obj,
          Object.keys(this)
        )),
        {
          mimeType: obj.mimeType ? convertToValue(
            MimeTypes,
            obj.mimeType
          ) || defaultFileData.mimeType : defaultFileData.mimeType
        }
      );
    } else {
      Object.assign(
        this,
        defaultFileData
      );
    }
  }

  static readonly required = { id: true };

  static default(): any {
    return { ...new CreateFileInput() }
  }

  validate(keys: Array<string>): any {
    return validateRequiredNotDefault(
      {},
      CreateFileManageable.required,
      this,
      CreateFileManageable.default(),
      keys
    );
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    data.mimeType = convertToKey(
      MimeTypes,
      data.mimeType
    );

    return data;
  }
}

export class GenerateSignedUrlManageable extends GenerateUploadSignedUrlInput {
  constructor(obj?: any) {
    super();

    obj && Object.assign(
      this,
      prune(obj)
    );
  }

  static readonly required = { mimeTypes: true };

  static default(): any {
    return { ...new GenerateUploadSignedUrlInput() }
  }

  validate(keys: Array<string>): any {
    return validateRequiredNotDefault(
      {},
      CreateFileManageable.required,
      this,
      CreateFileManageable.default(),
      keys
    );
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    data.mimeTypes = data.mimeTypes.map((mimeType: string) => {
      return convertToKey(
        MimeTypes,
        mimeType
      ) || '';
    });

    return data;
  }
}

